module.exports = __webpack_public_path__ + "img/panel-economic-update.2ad2b3a6.svg";